import { USER_EVENTS } from "@src/constants";
import { PlayerEventType, PlayerState } from "amazon-ivs-player";

export const TRACK_EVENT_SCREENS = {
  FACILITY_PROFILE: "Facility Profile",
  OPEN_SHIFT_CARD: "Open Shift Card",
};

const { ENDED, READY } = PlayerState;
const { INITIALIZED } = PlayerEventType;

export const FACILITY_VIDEO_USER_EVENTS = {
  [INITIALIZED]: USER_EVENTS.FACILITY_VIDEO_OPENED,
  [READY]: USER_EVENTS.FACILITY_VIDEO_STARTED,
  [ENDED]: USER_EVENTS.FACILITY_VIDEO_ENDED,
};
